import { ReactText } from "react";
import { useStyle } from "./style";
import { Grid, GridSize, Typography } from "@mui/material";

interface IParams {
    fieldName: string;
    itemGridSize?: GridSize;
    value: ReactText | null | undefined;
}

export const InlineItem = (props: IParams) => {
    const { value, fieldName, itemGridSize } = props;
    const { classes } = useStyle();

    const typographyValue = (
        <Typography className={classes.value} variant="small">
            {value}
        </Typography>
    );

    return (
        <>
            <Grid className={classes.gridField} item md={itemGridSize ?? 4} xs={12}>
                <Typography color="textPrimary" display="inline" variant="small">
                    {fieldName}:&nbsp;
                </Typography>
                {itemGridSize && typographyValue}
            </Grid>
            {!itemGridSize && (
                <Grid className={classes.gridValue} item md={7} xs={12}>
                    {typographyValue}
                </Grid>
            )}
        </>
    );
};
